import React from 'react';
export const SectionEyebrow: React.FC<{
  children: React.ReactNode;
  light?: boolean;
}> = ({
  children,
  light
}) => <div className="flex items-center justify-center gap-4 mb-7" data-id="element-58">
    <span className={`h-px w-12 ${light ? 'bg-gold-deep/40' : 'bg-gold/40'}`} data-id="element-59" />
    <span className={`text-[10px] uppercase tracking-eyebrow font-medium ${light ? 'text-gold-deep' : 'text-gold'}`} data-id="element-60">
      {children}
    </span>
    <span className={`h-px w-12 ${light ? 'bg-gold-deep/40' : 'bg-gold/40'}`} data-id="element-61" />
  </div>;